class ProductBuilder extends HTMLElement {
  constructor() {
    super();

    this.updateSelectedPart = this.updateSelectedPart.bind(this);
    this.updateBundleInfo = this.updateBundleInfo.bind(this);
    this.updateBundleBandit = this.updateBundleBandit.bind(this);

    this.updatePricing = this.updatePricing.bind(this);
    this.getBuilderSelections = this.getBuilderSelections.bind(this);
    this.submitBuild = this.submitBuild.bind(this);

    this.openBuilder = this.openBuilder.bind(this);
    this.switchBuilderTab = this.switchBuilderTab.bind(this);
    this.resizeBuilder = this.resizeBuilder.bind(this);

    this.setBuilderElementsSticky = this.setBuilderElementsSticky.bind(this);

    this.handleOptionSetMenuItemClick = this.handleOptionSetMenuItemClick.bind(this);
    this.handleOptionSetMenuNavClick = this.handleOptionSetMenuNavClick.bind(this);

    this.handleCustomizeVersion = this.handleCustomizeVersion.bind(this);

    this.handleBuilderSummaryInfo = this.handleBuilderSummaryInfo.bind(this);

    this.handleFirstIntersectofCustomize = this.handleFirstIntersectofCustomize.bind(this);

    this.scrollToMainTab = this.scrollToMainTab.bind(this);

    this.handleVariantChange = this.handleVariantChange.bind(this);

    this.getBuilderJsonData = this.getBuilderJsonData.bind(this);

    this.getMasterBanditImage = this.getMasterBanditImage.bind(this);

    this.handleCustomizeEnableDisable = this.handleCustomizeEnableDisable.bind(this);

    this.updateVariantSelectorsToDefaultVariant = this.updateVariantSelectorsToDefaultVariant.bind(this);

    this.updateBundleBackground = this.updateBundleBackground.bind(this);

    this.openCloseMobileBundleBackgroundSelector = this.openCloseMobileBundleBackgroundSelector.bind(this);

    this.getImageFromAmazonS3 = this.getImageFromAmazonS3.bind(this);

    this.getImageFromShopify = this.getImageFromShopify.bind(this);

    this.handleGwpItemClick = this.handleGwpItemClick.bind(this);

    this.handleLegacyBanditSetup = this.handleLegacyBanditSetup.bind(this);

    class GroupPart {
      constructor(groupPart) {
        this.isSelected = this.isSelected.bind(this);

        this.groupPart = groupPart;
        this.input = this.groupPart.querySelector('.js-builder-option-input');
      }

      isSelected() {
        return this.input.checked;
      }
    }

    class OptionSet {
      constructor(group, builder, builder_type) {
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.openNextGroup = this.openNextGroup.bind(this);
        this.closeGroups = this.closeGroups.bind(this);
        this.scrollToTarget = this.scrollToTarget.bind(this);
        this.scrollIntoViewOptionSetMenuItem = this.scrollIntoViewOptionSetMenuItem.bind(this);
        this.changeCustomize2dSlide = this.changeCustomize2dSlide.bind(this);

        this.group = group;
        this.builder = builder;
        this.builder_type = builder_type;

        this.elements = {
          toggle: this.group.querySelectorAll('.js-builder-option-set-toggle'),
          item_container: this.group.querySelector('.js-builder-options'),
        };

        this.option_set_options = Array.from(this.group.querySelectorAll('.js-builder-option')).map((option_set_option) => new GroupPart(option_set_option));

        Array.from(this.elements.toggle).forEach((element) => {
          element.addEventListener('click', () => {
            if (this.group.classList.contains('is-open')) {
              this.openNextGroup();
            } else {
              this.open();
            }
          });
        });
      }

      open(scroll) {
        this.closeGroups();
        this.group.classList.add('is-open');

        Array.from(this.builder.elements[this.builder_type].option_set_menu_items).forEach((el) =>
          el.dataset.anchor === this.group.dataset.anchor ? el.classList.add('active') : el.classList.remove('active'),
        );

        this.scrollIntoViewOptionSetMenuItem();
        if (scroll !== false) this.scrollToTarget();

        if (this.builder_type === 'customize') this.changeCustomize2dSlide();
        let total_height = 0;

        this.option_set_options.forEach((part, i) => {
          const style = window.getComputedStyle(part.groupPart);
          let height = part.groupPart.getBoundingClientRect().height;
          height = ['top', 'bottom'].map((side) => parseInt(style[`margin-${side}`], 10)).reduce((total, side) => total + side, height);
          total_height += height;
        });

        this.elements.item_container.style.height = `${total_height}px`;
      }

      close(force) {
        if (!this.group.classList.contains('is-open') && !force) {
          return;
        }

        this.group.classList.remove('is-open');

        let total_height = 0;
        this.elements.item_container.style.height = `${total_height}px`;
      }

      openNextGroup() {
        let option_sets_array = [];
        if (this.builder_type === 'bundle') option_sets_array = this.builder.option_sets_bundle;
        if (this.builder_type === 'customize') option_sets_array = this.builder.option_sets_customize;

        const next_index = option_sets_array.indexOf(this) + 1;
        const next_groups_closed = option_sets_array.slice(next_index).every((option_set) => !option_set.group.classList.contains('is-open'));

        if (next_groups_closed && next_index < option_sets_array.length) {
          option_sets_array[next_index].open();
        } else {
          this.close();
        }
      }

      closeGroups() {
        if (this.builder_type === 'bundle') return this.builder.option_sets_bundle.forEach((optionSet) => optionSet.close());
        if (this.builder_type === 'customize') return this.builder.option_sets_customize.forEach((optionSet) => optionSet.close());
      }

      changeCustomize2dSlide() {
        const activeTab = Array.from(this.builder.elements.builder_tabs).find((tab) => tab.classList.contains('active') && tab.dataset && tab.dataset.tab);
        if (activeTab && activeTab.dataset.tab === 'customize' && this.builder.customize_2d) {
          this.group.dispatchEvent(
            new CustomEvent('optionSetMenuSelectedChanged', {
              detail: {
                optionSetIndex: this.group.dataset.builderOptionSetIndex,
                optionSetElement: this.group,
              },
            }),
          );
        }
      }

      scrollToTarget() {
        const currentGroups = Array.from(this.group.parentElement.querySelectorAll('.option-set'));
        let scrollAmount = 0;

        if (this.builder.elements.page_navigation) scrollAmount -= this.builder.elements.page_navigation.offsetHeight;
        if (this.builder.elements.builder_tabs_wrapper) {
          scrollAmount -= this.builder.elements.builder_tabs_wrapper.offsetHeight;
          scrollAmount -= parseInt(window.getComputedStyle(this.builder.elements.builder_tabs_wrapper).getPropertyValue('padding-bottom'));
        }

        for (const currentGroup of currentGroups) {
          scrollAmount += 1;
          if (currentGroup === this.group) {
            scrollAmount += parseInt(window.getComputedStyle(currentGroup.querySelector('.option-set__title')).getPropertyValue('padding-top'));
            break;
          }
          if (currentGroup !== this.group) {
            if (currentGroup.classList.contains('option-set__mandatory')) {
              scrollAmount += currentGroup.getBoundingClientRect().height;
            } else {
              scrollAmount += currentGroup.querySelector('.option-set__title').getBoundingClientRect().height;
            }
          }
        }

        scrollAmount += this.builder.elements[this.builder_type].container.getBoundingClientRect().top;

        scrollAmount += window.scrollY;

        window.scrollTo({
          top: scrollAmount,
          behavior: 'smooth',
        });
      }

      scrollIntoViewOptionSetMenuItem() {
        const anchorMatch = Array.from(this.builder.elements[this.builder_type].option_set_menu_items).find(
          (anchorTarget) => anchorTarget.dataset.anchor === this.group.dataset.anchor,
        );
        if (anchorMatch) {
          const containerElement = this.builder.elements[this.builder_type].option_set_menu_scroll_container;
          let scrollAmount = anchorMatch.offsetLeft;
          containerElement.scrollTo({ left: scrollAmount - 28, behavior: 'smooth' });
        }
      }
    }

    class ClickableGroupPart {
      constructor(clickableGroupPart, builder) {
        this.updateInfo = this.updateInfo.bind(this);

        this.clickableGroupPart = clickableGroupPart;
        this.builder = builder;
        this.input = this.clickableGroupPart.querySelector('.js-builder-option-input');
        this.part_checkbox = this.clickableGroupPart.querySelector('[type="checkbox"].js-builder-option-input');

        this.clickableGroupPart.addEventListener('change', this.updateInfo, false);
      }

      updateInfo(e) {
        if (this.input && this.input.type === 'radio' && this.input.checked !== true) return;

        // Ignore click events on enabled checkboxes (will use the change event instead)
        if (this.input && this.input.type === 'checkbox' && !this.input && e.type === 'click') return;

        // update GWP selections if they exist
        const gwp_items = Array.from(this.builder.elements.gwp_items) || [];
        if (gwp_items && gwp_items.length > 0) {
          gwp_items.forEach((gwpItem) => {
            const inputGwp = gwpItem.querySelector('.js-builder-option-input');
            if (this.input.name === inputGwp.name) {
              if (this.input.value === '') {
                inputGwp.checked = false;
              } else {
                if (this.input.value === inputGwp.value) {
                  inputGwp.checked = this.input.checked;
                }
              }
            }
          });

          if (this.builder.elements.gwp_choose) {
            const checkedItems = gwp_items.filter((item) => item.querySelector('.js-builder-option-input').checked);
            if (this.part_checkbox) {
              this.builder.elements.gwp_choose.textContent = `Choose your gifts! (${checkedItems.length} out of ${gwp_items.length} selected)`;
            } else {
              this.builder.elements.gwp_choose.textContent = `Choose one gift! (${checkedItems.length} out of 1 selected)`;
            }
          }
        }

        // Clear bandit when unchecking a checkbox
        const clear = this.input && !this.input.checked;

        // update bundle related selections
        this.builder.updateSelectedPart(this);
        this.builder.updateBundleInfo(this.clickableGroupPart, clear);
        this.builder.updateBundleBandit('option', this.clickableGroupPart, clear);
      }
    }

    class Customize2d {
      constructor(customize2dwrapper, builder) {
        this.customize2dWrapper = customize2dwrapper;
        this.builder = builder;
        this.masterProductLabel = this.builder.querySelector('.option-set__master label');
        this.customizeOptions = this.builder.querySelectorAll('.js-builder-option[data-builder="customize"]');

        this.slider = this.customize2dWrapper.querySelector('[id^="Slider-"]');
        this.sliderItems = this.customize2dWrapper.querySelectorAll('[id^="Slide-"]');
        this.prevButton = this.customize2dWrapper.querySelector('button[name="previous"]');
        this.nextButton = this.customize2dWrapper.querySelector('button[name="next"]');
        this.sliderControlWrapper = this.customize2dWrapper.querySelector('.slider-buttons');
        this.sliderControlButtons = this.sliderControlWrapper.querySelectorAll('.slider-counter__link');

        this.swapImage = this.swapImage.bind(this);

        if (!this.slider || !this.nextButton || !this.sliderControlWrapper) return;

        Array.from(this.sliderControlButtons).forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
        Array.from(this.builder.elements.customize.option_sets).forEach((el) => el.addEventListener('optionSetMenuSelectedChanged', this.linkToSlide.bind(this)));
        Array.from(this.builder.elements.customize.options).forEach((el) => el.addEventListener('change', this.swapImage));
        this.customize2dWrapper.addEventListener(
          'customizeSlideChanged',
          debounce((e) => this.builder.handleOptionSetMenuItemClick(this.sliderItemsToShow[e.detail.currentPage - 1], 'customize'), 250),
        );

        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();
      }

      initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        this.update();
      }

      resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
      }

      update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPage != previousPage) {
          this.customize2dWrapper.dispatchEvent(
            new CustomEvent('customizeSlideChanged', {
              detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1],
              },
            }),
          );
        }

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach((link) => {
          link.classList.remove('slider-counter__link--active');
          link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
      }

      isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
      }

      onButtonClick(event) {
        event.preventDefault();
        let nextPage = this.currentPage;

        if (event.currentTarget.name === 'next') {
          nextPage = nextPage - 1 + 1;
        } else if (event.currentTarget.name === 'previous') {
          nextPage = nextPage - 1 - 1;
        }

        this.slideScrollPosition = nextPage * this.sliderItemOffset;
        this.slider.scrollTo({
          left: this.slideScrollPosition,
        });
      }

      linkToSlide(event) {
        event.preventDefault();
        let nextPage =
          event.detail && event.detail.optionSetIndex
            ? parseInt(event.detail.optionSetIndex) + 1 - this.currentPage
            : Array.from(this.sliderControlButtons).indexOf(event.currentTarget) + 1 - this.currentPage;
        if (nextPage === 0) return;
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderItemOffset * nextPage;
        this.slider.scrollTo({
          left: this.slideScrollPosition,
        });
      }

      setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
          const linkElements = item.querySelectorAll('a');
          if (index === this.currentPage - 1) {
            if (linkElements.length)
              linkElements.forEach((button) => {
                button.removeAttribute('tabindex');
              });
            item.setAttribute('aria-hidden', 'false');
            item.removeAttribute('tabindex');
          } else {
            if (linkElements.length)
              linkElements.forEach((button) => {
                button.setAttribute('tabindex', '-1');
              });
            item.setAttribute('aria-hidden', 'true');
            item.setAttribute('tabindex', '-1');
          }
        });
      }

      swapImage(e) {
        const optionLabel = e.currentTarget;
        const optionSet = optionLabel.parentElement.parentElement;
        if (optionSet.dataset.builderOptionSetIndex) {
          const index = parseInt(optionSet.dataset.builderOptionSetIndex);
          const currentSlide = this.sliderItemsToShow[index];
          if (currentSlide) {
            if (optionLabel.dataset.image) {
              currentSlide.children[0].src = optionLabel.dataset.image;
              currentSlide.children[0].alt = optionLabel.dataset.title;
            } else {
              currentSlide.children[0].src = NO_IMAGE;
              currentSlide.children[0].alt = 'No Image';
            }
          }
        }
      }
    }

    class Customize3d {
      constructor(customize3dwrapper, builder) {
        this.createScene = this.createScene.bind(this);
        this.createLoaders = this.createLoaders.bind(this);
        this.createCanvasEl = this.createCanvasEl.bind(this);
        this.getContainerDimensions = this.getContainerDimensions.bind(this);
        this.handleCanvasExpand = this.handleCanvasExpand.bind(this);
        this.handleCanvasExpandInit = this.handleCanvasExpandInit.bind(this);
        this.handleCanvasExpandReset = this.handleCanvasExpandReset.bind(this);
        this.createCamera = this.createCamera.bind(this);
        this.createControls = this.createControls.bind(this);
        this.createRenderer = this.createRenderer.bind(this);
        this.createSceneEnvironment = this.createSceneEnvironment.bind(this);
        this.tick = this.tick.bind(this);
        this.loadGltf = this.loadGltf.bind(this);
        this.loadParts = this.loadParts.bind(this);
        this.centerModelUpdateCamera = this.centerModelUpdateCamera.bind(this);
        this.loadModelsForScene = this.loadModelsForScene.bind(this);
        this.addNewPart = this.addNewPart.bind(this);
        this.enableDepthWrite = this.enableDepthWrite.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.changePart = this.changePart.bind(this);
        this.hideLoader = this.hideLoader.bind(this);
        this.disposeOldPart = this.disposeOldPart.bind(this);
        this.handleDisposeModel = this.handleDisposeModel.bind(this);
        this.handleDisposeEverything = this.handleDisposeEverything.bind(this);
        this.load3dEnv = this.load3dEnv.bind(this);
        this.loadBuilder3dModules = this.loadBuilder3dModules.bind(this);

        this.customize3dWrapper = customize3dwrapper;
        this.builder = builder;
        this.masterProductLabel = this.builder.querySelector('.option-set__master label');
        this.customizeOptions = this.builder.querySelectorAll('.js-builder-option[data-builder="customize"]');
        this.canvasContainer = this.customize3dWrapper.querySelector('.customize-3d-container');
        this.containerWidth = this.canvasContainer.clientWidth;
        this.containerHeight = this.canvasContainer.clientHeight;
        this.canvas;
        this.renderer;
        this.camera;
        this.controls;
        this.gltfLoader;
        this.rgbeLoader;
        this.envMap;
        this.box;
        this.size;
        this.center;
        this.scene;
        this.skeleton;
        this.chassis;
        this.anim_id;
        this.three;
        this._remove;

        // used for canvas expand
        this.initialContainerHeight = this.containerHeight;
        this.canvasExpandBtn = this.customize3dWrapper.querySelector('.expander');
        this.canvasExpandCloseBtn = this.customize3dWrapper.querySelector('.expander-close');

        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (entries[0].isIntersecting) {
              console.log('load modules');
              this.loadBuilder3dModules();
              observer.disconnect();
            }
          },
          { rootMargin: '0% 0% -50% 0%' },
        );

        this.observer.observe(this.builder.elements.customize.container);
      }

      async loadBuilder3dModules() {
        const { Scene, PerspectiveCamera, WebGLRenderer, PMREMGenerator, sRGBEncoding, ACESFilmicToneMapping, Box3, Vector3, Quaternion, Texture, LoadingManager } =
          await import('./three.module.js');
        const { OrbitControls } = await import('./three.module.orbitControls.js');
        const { GLTFLoader } = await import('./three.module.gltfLoader.js');
        const { RGBELoader } = await import('./three.module.rgbeLoader.js');
        const { default: remove } = await import('./lodash-es._remove.js');

        this._remove = remove;
        this.three = {
          Scene,
          PerspectiveCamera,
          WebGLRenderer,
          PMREMGenerator,
          sRGBEncoding,
          ACESFilmicToneMapping,
          Box3,
          Vector3,
          Quaternion,
          Texture,
          LoadingManager,
          OrbitControls,
          GLTFLoader,
          RGBELoader,
        };
      }

      createScene() {
        this.scene = new this.three.Scene();
      }

      // Loaders
      createLoaders() {
        this.loadingManager = new this.three.LoadingManager(
          // onLoad
          () => {},

          // progress
          (itemUrl, itemsLoaded, itemsTotal) => {
            // calculate the progress
            const progressRatio = itemsLoaded / itemsTotal;
          },
          (error) => console.log(`An error occurred within loadingManager: ${error}`),
        );

        this.gltfLoader = new this.three.GLTFLoader(this.loadingManager);
      }

      // Create canvas element, append to DOM, and return data
      createCanvasEl() {
        this.canvas = document.createElement('canvas');
        this.canvas.setAttribute('style', 'outline:none;width:100%;height:100%;');
        this.canvasContainer.appendChild(this.canvas);
      }

      getContainerDimensions() {
        this.createCanvasEl();
        this.containerWidth = this.canvasContainer.clientWidth;
        this.containerHeight = this.canvasContainer.clientHeight;
        this.initialContainerHeight = this.containerHeight;
      }

      handleCanvasExpand() {
        // If customization-3d-container classlist has expanded then remove the class and divide the height by 2
        const expanded = this.canvasContainer.classList.contains('expanded');

        if (expanded) {
          this.builder.elements.customize.container.classList.remove('expanded');
          this.builder.elements.customize.builder_left.classList.remove('expanded');
          this.canvasContainer.classList.remove('expanded');
          this.handleResize();
          this.builder.setBuilderElementsSticky();
          return;
        }

        // If customization-3d-container classlist does not have expanded then add the class and multiplys the height by 2
        this.builder.elements.customize.container.classList.add('expanded');
        this.builder.elements.customize.builder_left.classList.add('expanded');
        this.canvasContainer.classList.add('expanded');
        this.handleResize();
        this.builder.setBuilderElementsSticky();

        const mobile = window.matchMedia('(max-width: 798px)');
        if (!mobile.matches) {
          this.builder.elements.builder_tabs_wrapper.style.zIndex = '-1';
          if (this.builder.elements.builder_sticky_bar) this.builder.elements.builder_sticky_bar.style.zIndex = '-1';
        }
      }

      handleCanvasExpandInit() {
        this.canvasExpandBtn.addEventListener('click', this.handleCanvasExpand);
        this.canvasExpandCloseBtn.addEventListener('click', this.handleCanvasExpand);
      }

      handleCanvasExpandReset() {
        this.canvasExpandBtn.removeEventListener('click', this.handleCanvasExpand);
        this.builder.elements.customize.builder_left.classList.remove('expanded');
        this.canvasContainer.classList.remove('expanded');
        this.canvasExpandCloseBtn.removeEventListener('click', this.handleCanvasExpandReset);
      }

      // Camera
      createCamera() {
        this.camera = new this.three.PerspectiveCamera(45, this.containerWidth / this.containerHeight, 0.1, 1000);
        this.scene.add(this.camera);
      }

      // Controls
      createControls() {
        this.controls = new this.three.OrbitControls(this.camera, this.canvas);
        this.controls.enableDamping = true;
        this.controls.enablePan = false;
        this.controls.dampingFactor = 0.1;
        this.controls.minDistance = 0;
        this.controls.maxDistance = 1;
        this.controls.enableZoom = true;
        this.controls.maxPolarAngle = (95 * Math.PI) / 180;
        this.controls.zoomSpeed = 0.5;
      }

      // Renderer
      createRenderer() {
        this.renderer = new this.three.WebGLRenderer({
          antialias: true,
          alpha: true,
          canvas: this.canvas,
        });

        this.renderer.physicallyCorrectLights = true;
        this.renderer.outputEncoding = this.three.sRGBEncoding;
        this.renderer.toneMappingExposure = 3;
        this.renderer.toneMapping = this.three.ACESFilmicToneMapping;
        this.renderer.setSize(this.containerWidth, this.containerHeight);
        this.renderer.setPixelRatio(window.devicePixelRatio);
      }

      // Scene environment
      createSceneEnvironment(scene, renderer) {
        let pmremGenerator = new this.three.PMREMGenerator(renderer);
        pmremGenerator.compileEquirectangularShader();

        this.rgbeLoader = new this.three.RGBELoader();

        this.rgbeLoader.load('https://s3.us-east-2.amazonaws.com/www.dallacorte-usa.com/hdr_environments/lightroom_grey_walls.hdr', (hdr) => {
          const envMap = pmremGenerator.fromEquirectangular(hdr);
          scene.environment = envMap.texture;
          hdr.dispose();
          pmremGenerator.dispose();
          pmremGenerator = undefined;
        });
      }

      // Animate
      tick() {
        // update controls
        this.controls.update();

        // render
        this.renderer.render(this.scene, this.camera);

        // call tick again on next frame
        this.anim_id = requestAnimationFrame(this.tick);
      }

      async loadGltf(uri) {
        return await new Promise((resolve) => {
          return this.gltfLoader.load(uri, resolve);
        });
      }

      async loadParts(uri, status) {
        return await this.loadGltf(uri, status);
      }

      centerModelUpdateCamera(threeGroup) {
        this.box = new this.three.Box3().setFromObject(threeGroup);
        this.size = this.box.getSize(new this.three.Vector3()).length();
        this.center = this.box.getCenter(new this.three.Vector3());

        threeGroup.traverse((child) => {
          if (child.name !== 'skeleton' || child.name !== 'skeleton-bounding-box') {
            child.position.sub(this.center);
          }
        });

        if (this.camera) {
          this.camera.near = this.size / 100;
          this.camera.far = this.size * 100;

          this.camera.position.copy(new this.three.Vector3(0, this.center.y + this.size, 0));

          const quaternion = new this.three.Quaternion();
          this.camera.position.applyQuaternion(quaternion.setFromAxisAngle(new this.three.Vector3(1, 0, 0), 75 * (Math.PI / 180))); // x-axis - rotate top 30 degrees in addition to initial load position
          this.camera.position.applyQuaternion(quaternion.setFromAxisAngle(new this.three.Vector3(0, 1, 0), 35 * (Math.PI / 180))); // y-axis - rotate right 10 degrees in addition to initial load position

          this.camera.updateProjectionMatrix();
        }
      }

      loadModelsForScene = async () => {
        const selectedOptions = Array.from(this.customizeOptions).filter((element) => element.querySelector('.js-builder-option-input:checked'));
        for (const selectedOption of selectedOptions) {
          if (selectedOption.dataset.customizeModel) {
            const hardpoint = selectedOption.dataset.customizeHardpoint;
            const scenePartName = `${hardpoint}-model`;
            const gltf = await this.loadParts(selectedOption.dataset.customizeModel);
            this.disposeOldPart(scenePartName);
            this.addNewPart(scenePartName, hardpoint, gltf);
          }
        }
      };

      addNewPart = (partName, hardPoint, gltf) => {
        gltf.scene.name = partName;
        this.enableDepthWrite(gltf.scene);

        this.scene.traverse((child) => {
          if (child.name === hardPoint) {
            gltf.scene.position.add(child.position);
          }
        });

        this.scene.add(gltf.scene);
      };

      // needed for layered transparency
      enableDepthWrite = (gltf) => {
        gltf.traverse((o) => {
          if (o.material) {
            // material is an array
            if (o.material.length) {
              for (let i = 0; i < o.material.length; ++i) {
                o.material[i].depthWrite = true;
              }
            } else {
              // material is an object
              o.material.depthWrite = true;
            }
          }
        });
      };

      handleResize = async () => {
        this.containerWidth = this.canvasContainer.clientWidth;
        this.containerHeight = this.canvasContainer.clientHeight;
        // resize canvas using canvas container
        this.camera.aspect = this.containerWidth / this.containerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.containerWidth, this.containerHeight);
      };

      changePart = async (e) => {
        const currentTarget = e.currentTarget;

        if (currentTarget && currentTarget.dataset.customizeHardpoint) {
          const hardpoint = currentTarget.dataset.customizeHardpoint;
          const scenePartName = `${hardpoint}-model`;
          const gltf = await this.loadParts(currentTarget.dataset.customizeModel);
          this.disposeOldPart(scenePartName);
          this.addNewPart(scenePartName, hardpoint, gltf);
        }
      };

      hideLoader = (bool) => {
        const loader = document.getElementById('loading-screen');
        bool ? loader.classList.add('fade-out') : loader.classList.remove('fade-out');
      };

      disposeOldPart = (childName) => {
        let sceneArray = [];
        this.scene.traverse((child) => sceneArray.push(child));

        let filteredArrRemovedEls = this._remove(sceneArray, (child) => child.name === childName);
        filteredArrRemovedEls.forEach((child) => {
          this.scene.remove(child);
          this.handleDisposeModel(child);
        });
      };

      handleDisposeModel = (model) => {
        this.scene.remove(model);

        model.traverse((o) => {
          // check geometry and dispose
          if (o.geometry) {
            o.geometry.dispose();
            o.geometry = undefined;
          }
          // check material and dispose
          if (o.material) {
            // material is an array
            if (o.material.length) {
              for (let i = 0; i < o.material.length; ++i) {
                // check if there are any textures on the material
                for (let value of Object.values(o.material[i])) {
                  if (value instanceof this.three.Texture) {
                    value.dispose();
                    value = undefined;
                  }
                }
                o.material[i].dispose();
                o.material[i] = undefined;
              }
            } else {
              // material is an object
              // check if there are any textures on the material
              for (let value of Object.values(o.material)) {
                if (value instanceof this.three.Texture) {
                  value.dispose();
                  value = undefined;
                }
              }
              o.material.dispose();
              o.material = undefined;
            }
          }
        });
      };

      load3dEnv = async () => {
        await this.loadBuilder3dModules();
        this.createLoaders();
        this.scene ? this.scene : this.createScene();
        this.getContainerDimensions();
        this.createCamera();
        this.createControls();
        this.createRenderer();
        this.handleCanvasExpandInit();

        // kick off animation
        this.tick();

        // create scene environment
        this.createSceneEnvironment(this.scene, this.renderer);

        this.skeleton = await this.loadParts(this.masterProductLabel.dataset.customizeSkeleton); //modelSkeletonUri
        this.skeleton.scene.name = 'skeleton';

        this.scene.add(this.skeleton.scene);
        this.centerModelUpdateCamera(this.skeleton.scene);

        this.chassis = await this.loadParts(this.masterProductLabel.dataset.customizeModel); //chassisUri
        this.chassis.scene.name = 'chassis-model';
        this.scene.traverse((child) => {
          if (child.name === 'chassis') {
            this.chassis.scene.position.add(child.position);
          }
        });

        this.scene.add(this.chassis.scene);

        await this.loadModelsForScene();

        window.addEventListener('resize', this.handleResize);
        this.customizeOptions.forEach((element) => element.addEventListener('change', this.changePart));

        // call fn to get container size and update projection matrix now that models are in
        this.handleResize();
        this.hideLoader(true);
      };

      handleDisposeEverything = () => {
        this.scene.traverse((o) => {
          // check geometry and dispose
          if (o.geometry) {
            o.geometry.dispose();
            o.geometry = undefined;
          }
          // check material and dispose
          if (o.material) {
            // material is an array
            if (o.material.length) {
              for (let i = 0; i < o.material.length; ++i) {
                // check if there are any textures on the material
                for (let value of Object.values(o.material[i])) {
                  if (value instanceof this.three.Texture) {
                    value.dispose();
                    value = undefined;
                  }
                }
                o.material[i].dispose();
                o.material[i] = undefined;
              }
            } else {
              // material is an object
              // check if there are any textures on the material
              for (let value of Object.values(o.material)) {
                if (value instanceof this.three.Texture) {
                  value.dispose();
                  value = undefined;
                }
              }
              o.material.dispose();
              o.material = undefined;
            }
          }
        });

        this.scene.remove(this.camera);
        this.scene.remove(this.skeleton);
        this.scene.remove(this.chassis);

        this.scene.environment = null;
        if (this.envMap) {
          this.envMap.texture.dispose();
          this.envMap.dispose();
        }
        this.gltfLoader = undefined;
        this.rgbeLoader = undefined;
        this.camera = undefined;
        this.controls = undefined;
        this.skeleton = undefined;
        this.chassis = undefined;

        this.renderer.domElement = undefined;
        this.renderer.clear(true, true, true);
        this.renderer.renderLists.dispose();
        this.renderer.dispose();
        this.renderer.forceContextLoss();
        this.renderer = undefined;
        this.canvasContainer.removeChild(this.canvas);
        this.canvas = undefined;
        this.box = undefined;
        this.size = undefined;
        this.center = undefined;
        this.envMap = undefined;
        // scene.dispose(); no longer in three library
        this.scene = undefined;

        window.removeEventListener('resize', this.handleResize);
        this.customizeOptions.forEach((element) => element.removeEventListener('change', this.changePart));

        cancelAnimationFrame(this.anim_id);

        this.hideLoader(false);
        this.handleCanvasExpandReset();
      };
    }

    class SummaryModal {
      constructor(modal, builder) {
        this.modal = modal;
        this.builder = builder;
        this.modalOpener = document.querySelector('#builder-summary-modal-btn');
        this.modalClose = this.modal.querySelector('#builder-summary-modal-close');

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        this.modalOpener.addEventListener('click', (e) => {
          e.stopPropagation();
          this.show(this.modalOpener);
        });

        this.modalClose.addEventListener('click', this.hide);
        this.modal.addEventListener('keyup', (e) => {
          if (e.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) this.hide();
        });
      }

      show(opener) {
        this.openedBy = opener;
        document.body.classList.add('overflow-hidden');
        this.modal.setAttribute('open', '');
        trapFocus(this.modal, this.modal.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
      }

      hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.modal.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
      }
    }

    this.sectionId = this.dataset.sectionId ? this.dataset.sectionId : null;

    this.elements = {
      page_navigation: document.querySelector('.page-navigation'),
      form: this.querySelector('#builder_form'),

      bandit_fallback: this.querySelector('.bandit-fallback'),

      initial_builder_btn: document.querySelectorAll('.product-form__submit'),

      builder_tabs_wrapper: this.querySelector('#builder-tabs'),
      builder_tabs: this.querySelectorAll('.builder-tab'),
      builder_tabs_content_wrapper: this.querySelectorAll('#bundle, #customize'),

      options_form_error: this.querySelectorAll('.bundle-footer__pricing'),
      add_to_cart_bundle_btn: document.querySelector('button[type="submit"][name="bundle"]'),
      add_to_cart_btn: document.querySelectorAll('button[type="submit"][name="add-to-cart"]'),
      button_builder_bundle: document.querySelector('.button-builder-atc-bundle'),
      errors: this.querySelectorAll('.js-builder-option-set-required-error'),
      builder_option_sets: this.querySelectorAll('.js-builder-option-set'),

      bundle: this.getElements('bundle'),
      customize: this.getElements('customize'),

      savings_amount: document.querySelectorAll('.js-builder-savings'),
      total_price: document.querySelectorAll('.js-builder-total'),

      master_product: this.querySelector('.js-builder-option-input.js-master-part[data-builder="master"]'),
      master_product_label: this.querySelector('.js-builder-option[data-builder="master"]'),

      builder_bundle_sticky: this.querySelectorAll('.builder-tab[data-tab="bundle"]'),
      builder_customize_sticky: this.querySelectorAll('.builder-tab[data-tab="customize"], #view3D, #view2D'),

      // sticky builder pricing bar and summary modal
      builder_sticky_bar: document.querySelector('.product-sticky-bar'),
      builder_pricing_bar: document.querySelector('#builder-pricing-bar'),
      builder_summary_modal: document.querySelector('#builder-summary-modal'),
      builder_summary: document.querySelector('#builder-summary'),
      builder_summary_master: document.querySelector('#builder-summary .builder__summary-master-product'),
      builder_summary_bundle: document.querySelector('#builder-summary .builder__summary-bundle .builder__options-list'),
      builder_summary_customize: document.querySelector('#builder-summary .builder__summary-customize .builder__options-list'),

      variantSelector: document.querySelector(`variant-selects[data-section="${this.sectionId.replace('product-builder', 'main')}"]`),

      // gitf with purchase items
      gwp_choose: document.querySelector('#gift-with-purchase .gwp-choose'),
      gwp_items: document.querySelectorAll('#gift-with-purchase.product__gwp-items label.js-builder-option'),
    };

    this.getBuilderJsonData();

    this.summary_modal = null;
    this.customize_2d = null;
    this.customize_3d = null;
    this.legacy_bandit = { active: false, background: null };

    if (this.elements.builder_summary_modal) this.summary_modal = new SummaryModal(this.elements.builder_summary_modal, this);
    if (this.elements.customize.customize_viewer.viewer_2d) this.customize_2d = new Customize2d(this.elements.customize.customize_viewer.viewer_2d, this);
    if (this.elements.customize.customize_viewer.viewer_3d) this.customize_3d = new Customize3d(this.elements.customize.customize_viewer.viewer_3d, this);

    this.option_sets_bundle = Array.from(this.elements.bundle.option_sets).map((option_set) => new OptionSet(option_set, this, 'bundle'));
    this.option_sets_customize = Array.from(this.elements.customize.option_sets).map((option_set) => new OptionSet(option_set, this, 'customize'));

    this.options_bundle = Array.from(this.elements.bundle.options).map((option) => new ClickableGroupPart(option, this));
    // this.options_customize = Array.from(this.elements.bundle.options).map((option) => new ClickableGroupPart(option, this));

    // add event listener to GWP items
    if (this.elements.gwp_items)
      Array.from(this.elements.gwp_items).map((option) => ['click', 'change'].forEach((evt) => option.addEventListener(evt, this.handleGwpItemClick, false)));

    this.getMasterBanditImage();

    if (this.options_bundle.length > 0 && (this.elements.master_product_label.dataset.description || this.elements.master_product_label.dataset.banditImage)) {
      //display main product image in bandit
      this.updateBundleInfo(this.elements.master_product_label);
    } else {
      this.updateBundleInfo({ dataset: null }, true);
    }

    this.elements.initial_builder_btn.forEach((btn) => btn.addEventListener('click', this.openBuilder));
    this.elements.builder_tabs.forEach((tab) => tab.addEventListener('click', this.switchBuilderTab));

    this.elements.bundle.bundle_bandit_backgrounds.forEach((background) => background.addEventListener('click', this.updateBundleBackground));
    if (this.elements.bundle.bundle_bandit_bg_mobile_open)
      this.elements.bundle.bundle_bandit_bg_mobile_open.addEventListener('click', this.openCloseMobileBundleBackgroundSelector);
    if (this.elements.bundle.bundle_bandit_bg_mobile_close)
      this.elements.bundle.bundle_bandit_bg_mobile_close.addEventListener('click', this.openCloseMobileBundleBackgroundSelector);

    // option sets menu event listeners for each builder type
    this.elements.bundle.option_set_menu_items.forEach((el) => el.addEventListener('click', (e) => this.handleOptionSetMenuItemClick(e, 'bundle')));
    this.elements.customize.option_set_menu_items.forEach((el) => el.addEventListener('click', (e) => this.handleOptionSetMenuItemClick(e, 'customize')));
    this.elements.bundle.option_set_menu_nav.forEach((el) => el.addEventListener('click', (e) => this.handleOptionSetMenuNavClick(e, 'bundle')));
    this.elements.customize.option_set_menu_nav.forEach((el) => el.addEventListener('click', (e) => this.handleOptionSetMenuNavClick(e, 'customize')));

    this.elements.customize.customize_buttons.buttons.forEach((el) => el.addEventListener('click', this.handleCustomizeVersion));

    this.elements.form.addEventListener('submit', this.submitBuild);
    this.elements.add_to_cart_btn.forEach((btn) => btn.addEventListener('click', this.submitBuild));

    this.elements.form.addEventListener('change', this.updatePricing);
    this.updatePricing();
    window.addEventListener('resize', this.resizeBuilder);

    if (this.elements.variantSelector) this.elements.variantSelector.addEventListener('variantChanged', this.handleVariantChange);

    if (this.option_sets_bundle && this.option_sets_bundle.length >= 1) this.option_sets_bundle[0].open(false);
    if (this.option_sets_customize && this.option_sets_customize.length > 0) this.option_sets_customize[0].open(false);

    if (this.elements.customize.container) {
      this.handleCustomizeVersion();
      this.handleFirstIntersectofCustomize(this.elements.builder_tabs);
      this.handleCustomizeEnableDisable();

      this.elements.customize.disabled_overlay.querySelector('button[name="change-to-default-variant"]').addEventListener('click', this.updateVariantSelectorsToDefaultVariant);
    }

    if (this.builderJSON.outOfStock.status) {
      //update purchase action - disable atc
      Array.from([...this.elements.add_to_cart_btn, ...[this.elements.add_to_cart_bundle_btn], ...[this.elements.button_builder_bundle]]).forEach((atc_btn) => {
        if (!atc_btn) return;
        atc_btn.setAttribute('aria-disabled', true);
        atc_btn.setAttribute('disabled', 'true');
        atc_btn.classList.remove('builder_atc', 'button--primary');
        atc_btn.classList.add('builder_atc-oos', 'button--secondary-inverse');
        atc_btn.children[0].innerHTML = window.variantStrings.soldOut;
      });
    }
  }

  connectedCallback() {
    this.setBuilderElementsSticky();
  }

  getElements(builder_type) {
    const container = this.querySelector(`.builder__${builder_type}-container`);

    let title = null,
      builder_left = null,
      builder_right = null,
      option_set_menu = null,
      option_set_menu_nav = [],
      option_set_menu_scroll_container = null,
      option_set_menu_items = [],
      option_sets = [],
      options = [];

    if (container) {
      title = container.querySelector('.builder-section-title');
      builder_left = container.querySelector('.builder__left');
      builder_right = container.querySelector('.builder__right');
      option_set_menu = container.querySelector(`#${builder_type}-scrollable-menu`);
      option_set_menu_nav = Array.from(container.querySelectorAll(`.scroll-left, .scroll-right`));
      option_set_menu_scroll_container = container.querySelector('.scroll-container');
      option_set_menu_items = Array.from(container.querySelectorAll(`li.${builder_type}-anchor`));
      option_sets = Array.from(
        container.querySelectorAll(
          `.js-builder-option-set[data-builder-option-set-input-type="radio"][data-builder="${builder_type}"], .js-builder-option-set[data-builder-option-set-input-type="checkbox"][data-builder="${builder_type}"]`,
        ),
      );
      options = option_sets.reduce((acc, option_set) => (acc = [...acc, ...option_set.querySelectorAll('.js-builder-option')]), []);
    }

    const builder_type_data = {
      container,
      title,
      builder_left,
      builder_right,
      option_set_menu,
      option_set_menu_nav,
      option_set_menu_scroll_container,
      option_set_menu_items,
      option_sets,
      options,
    };
    if (builder_type === 'bundle') {
      const bundle_info = {
        container: container ? container.querySelector('.js-bundle-info') : null,
        info_image: container ? container.querySelector('.js-bundle-info-image') : null,
        info_title: container ? container.querySelector('.js-bundle-info-title') : null,
        info_description: container ? container.querySelector('.js-bundle-info-description') : null,
        info_link: container ? container.querySelector('.js-bundle-info-link') : null,
      };
      const bundle_bandit = container ? container.querySelector('#bundle_bandit') : null;
      const bundle_bandit_background = container ? container.querySelector('#bundle_bandit_background') : null;
      const bundle_bandit_backgrounds = container ? Array.from(container.querySelectorAll('#bundle_bandit_background > slider-component > ul > li > button')) : [];
      const bundle_bandit_bg_mobile_open = container ? container.querySelector('#mobile-bandit-bg-open') : null;
      const bundle_bandit_bg_mobile_close = container ? container.querySelector('#mobile-bandit-bg-close') : null;

      return {
        ...builder_type_data,
        bundle_info,
        bundle_bandit,
        bundle_bandit_background,
        bundle_bandit_backgrounds,
        bundle_bandit_bg_mobile_open,
        bundle_bandit_bg_mobile_close,
      };
    }

    if (builder_type === 'customize') {
      const customize_viewer = {
        container: container ? container.querySelector('#customize_viewer') : null,
        viewer_2d: container ? container.querySelector('.customize-2d-wrapper') : null,
        viewer_3d: container ? container.querySelector('.customize-3d-wrapper') : null,
      };
      const customize_buttons = {
        container: container ? container.querySelector('.customize-buttons') : null,
        buttons: container ? Array.from(container.querySelectorAll('.customize-version-btn')) : [],
      };
      return {
        ...builder_type_data,
        disabled_overlay: container ? container.querySelector('#builder-customize-disabled-overlay') : null,
        customize_viewer,
        customize_buttons,
      };
    }
  }

  updateSelectedPart(part) {
    this.options_bundle.forEach((bundle_part) =>
      bundle_part === part ? bundle_part.clickableGroupPart.classList.add('is-selected') : bundle_part.clickableGroupPart.classList.remove('is-selected'),
    );
  }

  updateBundleInfo(part, clear) {
    const dataset = part.dataset;

    if (dataset && dataset.description && !clear) {
      const image = dataset.image || '';
      const title = dataset.title || '';
      const link = dataset.url || '';
      const description = dataset.description || '';

      this.elements.bundle.bundle_info.info_image.src = image;
      this.elements.bundle.bundle_info.info_title.textContent = title;
      this.elements.bundle.bundle_info.info_description.textContent = description;
      this.elements.bundle.bundle_info.info_link.href = link;
      this.elements.bundle.bundle_info.container.style.display = 'flex';
    } else {
      this.elements.bundle.bundle_info.container.style.display = 'none';
    }
  }

  async updateBundleBandit(banditItem, part, clear) {
    const dataset = part.dataset;

    if (dataset && dataset.banditFrame) {
      const frame = dataset.banditFrame;
      const sku = dataset.sku;

      let bandit_image = null;

      if (!clear && frame && sku) {
        let shopifyImage = null;

        if (!this.legacy_bandit.active) {
          shopifyImage = await this.getImageFromShopify(sku, frame);
          if (shopifyImage) bandit_image = shopifyImage;
        }

        if (banditItem === 'master' && !shopifyImage) {
          const amazonImage = await this.getImageFromAmazonS3(sku, frame);
          if (amazonImage) bandit_image = amazonImage.imageSrc ? amazonImage.imageSrc : amazonImage;
          if (!this.legacy_bandit.active) {
            this.handleLegacyBanditSetup();
          }
        }

        if (!bandit_image && this.builderJSON.bundle.parameters.parentBanditFrame === frame && sku === 'NONE') {
          this.getMasterBanditImage();
        }
      }

      if (this.legacy_bandit.active && banditItem !== 'master') {
        const selected_legacy_background = this.builderJSON.bundle_background.legacy.find((bg) => bg.name === this.legacy_bandit.background);
        const empty_frame = `${selected_legacy_background[`${frame}_empty_frame`]}`;
        bandit_image = dataset.banditImage || empty_frame;
        if (clear) bandit_image = empty_frame;
      }

      const image_el = this.elements.bundle.bundle_bandit.querySelector(`#bandit-${frame}-image`);
      const hidden_image_el = this.elements.bundle.bundle_bandit.querySelector(`#bandit-hidden-image`);
      if (image_el) {
        if (!bandit_image) {
          if (!image_el.classList.contains('hidden')) image_el.classList.add('hidden');
          return;
        }
        if (bandit_image) {
          if (image_el.classList.contains('hidden')) image_el.classList.remove('hidden');
          image_el.src = bandit_image;
          if (hidden_image_el) hidden_image_el.src = bandit_image;
        }
      }
    }
  }

  updatePricing() {
    this.handleBuilderSummaryInfo();
    const builder_selections = this.getBuilderSelections();
    const total_savings = Shopify.formatMoney(builder_selections.total_savings, '${{ amount }}');
    const total_price = Shopify.formatMoney(builder_selections.total_price, '${{ amount }}');
    Array.from(this.elements.savings_amount).forEach((savings_el) => (savings_el.textContent = total_savings));
    Array.from(this.elements.total_price).forEach((price_el) => (price_el.textContent = total_price));
  }

  getBuilderSelections() {
    return Array.from(this.elements.builder_option_sets).reduce(
      (acc, group) => {
        const selected_products = group.querySelectorAll('.js-builder-option-input[type="hidden"], .js-builder-option-input:checked');

        const group_info = Array.from(selected_products).reduce(
          (acc, element) => {
            // need to exclude builder selections if customize is disabled
            if (!this.builderJSON.customize.enabled && element.dataset.builder === 'customize') return acc;

            const variant_id = element.value;

            if (!Number.isNaN(Number(parseFloat(variant_id)))) {
              // need to check if this is a customization product
              const isCustomizationProduct = element.dataset.builder === 'customize' ? true : false;
              // need to prevent adding a default customization option to cart (default customization option is already included with masterProduct)
              const defaultCustomizationOption = isCustomizationProduct && element.dataset.defaultOption === 'true' ? true : false;
              if (defaultCustomizationOption) return acc;

              const quantity = 1;
              const price = parseInt(element.dataset.price);
              const savings = parseInt(element.dataset.savings);

              acc.products_to_add.push({
                id: variant_id,
                quantity: quantity,
                price: price,
                customization: isCustomizationProduct,
              });

              acc.variant_keys.push(`${variant_id}:${quantity}`);

              if (price > 0) acc.total_price += price * quantity;
              if (savings > 0) acc.total_savings += savings * quantity;
            }

            return acc;
          },
          {
            products_to_add: [],
            variant_keys: [],
            total_price: 0,
            total_savings: 0,
          },
        );

        if (group.dataset.builderOptionSetRequired === 'true' && group_info.products_to_add.length === 0) {
          // do something here for customization to be excluded when factoryDefault is selected
          acc.missing_groups.push(group);
        }

        return {
          products_to_add: acc.products_to_add.concat(group_info.products_to_add),
          variant_keys: acc.variant_keys.concat(group_info.variant_keys),
          missing_groups: acc.missing_groups,
          total_price: acc.total_price + group_info.total_price,
          total_savings: acc.total_savings + group_info.total_savings,
        };
      },
      {
        products_to_add: [],
        variant_keys: [],
        missing_groups: [],
        total_price: 0,
        total_savings: 0,
      },
    );
  }

  submitBuild(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const builder_selections = this.getBuilderSelections();

    // hide previous errors
    Array.from(this.elements.errors).forEach((error_el) => {
      error_el.style.display = 'none';
    });

    // disable submit buttons
    Array.from(this.elements.add_to_cart_btn).forEach((atc_btn) => {
      atc_btn.setAttribute('aria-disabled', true);
      atc_btn.setAttribute('disabled', 'true');
      atc_btn.classList.add('loading');
      atc_btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    });

    // If there are required fields that don't have a selection, show error messaging and abort the add to cart
    if (builder_selections.missing_groups.length > 0) {
      Array.from(this.elements.add_to_cart_btn).forEach((atc_btn) => {
        atc_btn.setAttribute('aria-disabled', false);
        atc_btn.removeAttribute('disabled');
        atc_btn.classList.remove('loading');
        atc_btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
      builder_selections.missing_groups.forEach((group, i) => {
        const error_el = group.querySelector('.js-builder-option-set-required-error');
        if (error_el) error_el.style.display = 'block';
      });

      const group_0 = builder_selections.missing_groups[0];
      const matching_group_collapser = this.group_collapsers.find((group_collapser) => group_collapser.group.dataset.anchor === group_0.dataset.anchor);
      if (matching_group_collapser) matching_group_collapser.open();

      return;
    }

    /**************************************/
    /* START: COMBINE DUPLICATE PRODUCTS  */
    /*************************************/

    //1. gather duplicate product indexes from builder_selections.products_to_add
    let dupeIndexes = [];
    builder_selections.products_to_add.forEach((item, index) => {
      if (builder_selections.products_to_add.findIndex((ele) => ele.id === item.id) !== index) {
        dupeIndexes.push(index);
      }
    });

    //were there duplicates?
    if (!!dupeIndexes.length) {
      let combinedProdIndexes = []; //hold the indexes of summed products

      //2. loop thru dupe indexes and append combine qty and prices
      for (let dupeIndex of dupeIndexes) {
        //get dupe id and qty
        let dupeVariantId = builder_selections.products_to_add[dupeIndex].id;
        let qtyToAdd = builder_selections.products_to_add[dupeIndex].quantity;
        let priceToAdd = builder_selections.products_to_add[dupeIndex].price;

        //3. find first occurence of dupe product in builder_selections.products_to_add - this item will have qty and price added to it
        let productArrayIndex = builder_selections.products_to_add.findIndex((ele) => ele.id === dupeVariantId);
        builder_selections.products_to_add[productArrayIndex].quantity = builder_selections.products_to_add[productArrayIndex].quantity + qtyToAdd;
        builder_selections.products_to_add[productArrayIndex].price = builder_selections.products_to_add[productArrayIndex].price + priceToAdd;

        //4. use productArrayIndex to find first dupe in product builder_selections.variant_keys - this item will recieve a new qty
        if (builder_selections.variant_keys[productArrayIndex].includes(builder_selections.products_to_add[productArrayIndex].id)) {
          builder_selections.variant_keys[productArrayIndex] =
            builder_selections.products_to_add[productArrayIndex].id + ':' + builder_selections.products_to_add[productArrayIndex].quantity;
        }

        if (combinedProdIndexes.includes(productArrayIndex) === false) combinedProdIndexes.push(productArrayIndex);
      }

      //5. Set the new price using the new qty
      for (let prodIndex of combinedProdIndexes) {
        builder_selections.products_to_add[prodIndex].price = builder_selections.products_to_add[prodIndex].price / builder_selections.products_to_add[prodIndex].quantity;
      }

      //6. remove dupe products from builder_selections.products_to_add and builder_selections.variant_keys
      for (var i = dupeIndexes.length - 1; i >= 0; i--) {
        builder_selections.products_to_add.splice(dupeIndexes[i], 1);
        builder_selections.variant_keys.splice(dupeIndexes[i], 1);
      }
    }

    /************************************/
    /* END: COMBINE DUPLICATE PRODUCTS  */
    /************************************/

    var bundle_key = builder_selections.variant_keys.join('|');
    var bundle_instance_id =
      window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : `bundle-${Date.now()}-${Math.random().toString(36).slice(2)}`;

    var master_product = this.elements.master_product.name;
    var master_product_variant_id = this.elements.master_product.value;
    var master_product_variant_id_int = parseInt(master_product_variant_id);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    // Add every bundle line in one request. Non-master lines use Shopify's
    // nested cart line parent_id while legacy line-item properties keep the
    // existing cart display and discount integrations working.
    var builder_items_array_for_cart = builder_selections.products_to_add.reduce((items, element) => {
      const variant_id = parseInt(element.id);
      let object = {
        id: variant_id,
        quantity: element.quantity,
        properties: {
          _bundle_key: bundle_key,
          _bundle_instance_id: bundle_instance_id,
          _master: master_product,
          _master_id: master_product_variant_id,
          _bundle_price: element.price,
          _customization: element.customization,
        },
      };

      if (variant_id !== master_product_variant_id_int) {
        object.parent_id = master_product_variant_id_int;
      }

      if (variant_id === master_product_variant_id_int) {
        const additionalLineItemProperties = document.querySelectorAll('input[type="hidden"][name*=properties]');
        if (additionalLineItemProperties && additionalLineItemProperties.length > 0) {
          additionalLineItemProperties.forEach((lineItemProperty) => {
            const propertyName = lineItemProperty.name.replace('properties[', '').replace(']', '');
            const properyValue = lineItemProperty.value;
            object.properties[propertyName] = properyValue;
          });
        }
      }
      items.push(object);
      return items;
    }, []);

    builder_items_array_for_cart.sort((a, b) => {
      if (a.id === master_product_variant_id_int) return -1;
      if (b.id === master_product_variant_id_int) return 1;
      return 0;
    });

    config.body = JSON.stringify({ items: builder_items_array_for_cart });

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        const cart = document.querySelector('cart-items');

        if (response.status) {
          console.log('response error: ', response);
          this.error = true;
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        console.log('response normal');
        this.error = false;
        cart.updateCart(cart);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        Array.from(this.elements.add_to_cart_btn).forEach((atc_btn) => {
          atc_btn.setAttribute('aria-disabled', false);
          atc_btn.removeAttribute('disabled');
          atc_btn.classList.remove('loading');
          atc_btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      });
  }

  openBuilder(e) {
    if (e.handled === false) return;
    e.stopPropagation();
    e.preventDefault();
    e.handled = true;

    const triggerEl = e.currentTarget;
    const name = triggerEl?.name; // 'bundle' | 'customize'
    const targetTab = name === 'bundle' ? 'bundle' : name === 'customize' ? 'customize' : null;

    if (targetTab) {
      this._last_builder_trigger = triggerEl;
      this._last_builder_type = targetTab;
      this.a11yStartBuilderOpen(targetTab, triggerEl);
      this.switchBuilderTab({ currentTarget: { dataset: { tab: targetTab } } });
    }
  }

  switchBuilderTab(e) {
    const activeTab = e.currentTarget.dataset ? e.currentTarget.dataset.tab : null;

    Array.from(this.elements.builder_tabs).forEach((tab) => {
      const isActive = tab.dataset.tab === activeTab;
      tab.classList.toggle('active', isActive);

      // If you adopted the role="tab" buttons in Liquid:
      if (tab.getAttribute('role') === 'tab') {
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    });

    if (activeTab === 'bundle') {
      if (this.option_sets_bundle && this.option_sets_bundle.length >= 1) {
        this.option_sets_bundle[0].open();
        setTimeout(() => this.a11yFinalizeBuilderOpen('bundle'), 0);
      } else {
        this.scrollToMainTab('bundle', { afterScrollFinalizeA11y: true });
      }
    }

    if (activeTab === 'customize') {
      if (this.option_sets_customize && this.option_sets_customize.length >= 1) {
        this.option_sets_customize[0].open();
        setTimeout(() => this.a11yFinalizeBuilderOpen('customize'), 0);
      } else {
        this.scrollToMainTab('customize', { afterScrollFinalizeA11y: true });
      }
    }
  }

  resizeBuilder() {
    this.setBuilderElementsSticky();
  }

  setBuilderElementsSticky() {
    const mobile = window.matchMedia('(max-width: 798px)');
    const heightPageNav = this.elements.page_navigation ? this.elements.page_navigation.offsetHeight - 1 : 0;
    const heightTabs = this.elements.builder_tabs_wrapper.offsetHeight - 1;

    const heightBundleView = this.elements.bundle.bundle_bandit.offsetHeight;
    let totalHeightBundle = mobile.matches ? heightTabs + heightBundleView : heightTabs;

    const heightCustomizerView = this.elements.customize.customize_viewer.container ? this.elements.customize.customize_viewer.container.offsetHeight : 0;
    let totalHeightCustomizer = mobile.matches ? heightTabs + heightCustomizerView : heightTabs;

    if (this.elements.page_navigation) totalHeightBundle += heightPageNav;
    if (this.elements.page_navigation) totalHeightCustomizer += heightPageNav;
    if (this.elements.builder_tabs_wrapper) {
      this.elements.builder_tabs_wrapper.style.top = `${heightPageNav}px`;

      if (!mobile.matches) {
        this.elements.builder_tabs_wrapper.style.zIndex = '';
        if (this.elements.builder_sticky_bar) this.elements.builder_sticky_bar.style.zIndex = '';
      }
    }

    if (this.elements.bundle.builder_left) {
      this.elements.bundle.builder_left.style.top = mobile.matches ? `${heightPageNav + heightTabs}px` : `${heightPageNav}px`;
      this.elements.bundle.builder_left.style.marginTop = mobile.matches ? `0px` : `-${heightPageNav}px`;
    }
    if (this.elements.customize.builder_left) {
      this.elements.customize.builder_left.style.top = mobile.matches ? `${heightPageNav + heightTabs}px` : `${heightPageNav}px`;
      this.elements.customize.builder_left.style.marginTop = mobile.matches ? `0px` : `-5px`;
    }
    if (this.elements.bundle.option_set_menu) this.elements.bundle.option_set_menu.style.top = totalHeightBundle + 'px';

    if (this.elements.customize.option_set_menu) {
      if (this.elements.customize.customize_buttons.container) {
        this.elements.customize.option_set_menu.style.top = `${totalHeightCustomizer + this.elements.customize.customize_buttons.container.offsetHeight}px`;
      } else {
        this.elements.customize.option_set_menu.style.top = `${totalHeightCustomizer}px`;
      }
    }

    if (this.elements.customize.customize_buttons.container) {
      this.elements.customize.customize_buttons.container.style.top = `${totalHeightCustomizer}px`;
    }
  }

  handleOptionSetMenuItemClick(e, builder_type) {
    // handle target use for event listener and alternative target use for switchBuilderTabs
    const target = e && e.currentTarget ? e.currentTarget : e;
    const groupMatch = this[`option_sets_${builder_type}`].find((groupEl) => groupEl.group.dataset.anchor === target.dataset.anchor);
    if (groupMatch) {
      groupMatch.open();
    }
  }

  handleOptionSetMenuNavClick(e, builder_type) {
    const builder = e.currentTarget.dataset.builder;
    const direction = e.currentTarget.dataset.direction;
    const menu = builder === 'bundle' ? this.elements.bundle.option_set_menu_scroll_container : this.elements.customize.option_set_menu_scroll_container;
    let index = Array.from(menu.children).findIndex((child) => child.classList.contains('active'));
    if (direction === 'right') index = index === menu.children.length - 1 ? 0 : index + 1;
    if (direction === 'left') index = index === 0 ? menu.children.length - 1 : index - 1;
    this.handleOptionSetMenuItemClick(menu.children[index], builder_type);
  }

  handleCustomizeVersion(e) {
    const activeCustomizeVersion = Array.from(this.elements.customize.customize_buttons.buttons).find(
      (button) => button.classList.contains('active') && button.dataset && button.dataset.customizeVersion,
    );
    const target = e && e.currentTarget ? e.currentTarget : null;
    const newCustomizerVersion = target && target.dataset.customizeVersion ? e.currentTarget.dataset.customizeVersion : null;
    if (target)
      this.elements.customize.customize_buttons.buttons.forEach((button) =>
        button.dataset.customizeVersion === newCustomizerVersion ? button.classList.add('active') : button.classList.remove('active'),
      );
    const destroy = () => {
      let version = activeCustomizeVersion.dataset.customizeVersion;
      if (version === '2d') {
        this.customize_2d.customize2dWrapper.setAttribute('style', 'display:none');
      }
      if (version === '3d') {
        this.customize_3d.customize3dWrapper.setAttribute('style', 'display:none');
        this.customize_3d.handleDisposeEverything();
      }
    };

    const load = () => {
      let version = newCustomizerVersion ? newCustomizerVersion : activeCustomizeVersion.dataset.customizeVersion;
      if (newCustomizerVersion) {
        destroy();
      }
      if (version === '2d') {
        this.customize_2d.customize2dWrapper.setAttribute('style', 'display:block');
      }
      if (version === '3d') {
        this.customize_3d.customize3dWrapper.setAttribute('style', 'display:block;');
        this.customize_3d.load3dEnv();
      }
      this.resizeBuilder();
    };

    load();
  }

  handleBuilderSummaryInfo() {
    const summaryData = Array.from(this.elements.builder_option_sets).reduce(
      (acc, group) => {
        const selected_products = group.querySelectorAll('.js-builder-option-input[type="hidden"], .js-builder-option-input:checked');

        const group_info = Array.from(selected_products).reduce(
          (acc, element) => {
            // need to exclude builder selections if customize is disabled
            if (!this.builderJSON.customize.enabled && element.dataset.builder === 'customize') return acc;

            const variant_id = element.value;

            if (!Number.isNaN(Number(parseFloat(variant_id)))) {
              const quantity = 1;
              const price = parseInt(element.dataset.price);
              const savings = parseInt(element.dataset.savings);
              const title = element.parentElement.parentElement.querySelector('.option-set__product-title');
              let objectData = {
                id: variant_id,
                title: title ? title.textContent : 'No Title',
                quantity: quantity,
                price: price,
                savings: savings,
              };

              if (element.dataset.builder === 'master') {
                acc.master = objectData;
              }

              if (element.dataset.builder === 'bundle') {
                acc.bundle.push(objectData);
              }

              if (element.dataset.builder === 'customize') {
                const defaultCustomizeOption = element.dataset.defaultOption === 'true' ? true : false;
                acc.customize.push({ ...objectData, default: defaultCustomizeOption });
              }

              if (price > 0) acc.total_price += price * quantity;
              if (savings > 0) acc.total_savings += savings * quantity;
            }

            return acc;
          },
          {
            master: {},
            bundle: [],
            customize: [],
            total_price: 0,
            total_savings: 0,
          },
        );

        return {
          master: { ...acc.master, ...group_info.master },
          bundle: acc.bundle.concat(group_info.bundle),
          customize: acc.customize.concat(group_info.customize),
          total_price: acc.total_price + group_info.total_price,
          total_savings: acc.total_savings + group_info.total_savings,
        };
      },
      {
        master: {},
        bundle: [],
        customize: [],
        total_price: 0,
        total_savings: 0,
      },
    );

    const returnHtml = (dataArray, type) => {
      if (type === 'master') {
        const html = `
          <p class="master-title">${dataArray.title}</p>
          <p class="price">${Shopify.formatMoney(dataArray.price, '${{ amount }}')}</p>
        `;
        return html;
      }

      if (dataArray.length > 0) {
        const html = dataArray.map((product) => {
          const price = product.default ? 'Factory Default' : product.price === 0 ? 'free' : Shopify.formatMoney(product.price, '${{ amount }}');
          const savings = product.default || product.savings === 0 ? '' : Shopify.formatMoney(product.savings, '${{ amount }}');
          return `
            <div class="option-item">
              <p class="option-title">${product.title}</p>
              <div>
                <p class="price">${price}</p>
                ${savings === '' ? '' : `<p class="savings">Save ${savings}</p>`}
              </div>
            </div>
          `;
        });
        return html.join('');
      }

      if (type === 'bundle') {
        const html = '<div class="option-item"><p class="option-title">No Selection</p></div>';
        return html;
      }

      return '';
    };

    const masterSummaryHtml = returnHtml(summaryData.master, 'master');
    const bundleSummaryHtml = returnHtml(summaryData.bundle, 'bundle');
    const customizeSummaryHtml = returnHtml(summaryData.customize, 'customize');
    if (this.elements.builder_summary_master) this.elements.builder_summary_master.innerHTML = masterSummaryHtml;
    if (this.elements.builder_summary_bundle) this.elements.builder_summary_bundle.innerHTML = bundleSummaryHtml;
    if (this.elements.builder_summary_customize) this.elements.builder_summary_customize.innerHTML = customizeSummaryHtml;
  }

  handleFirstIntersectofCustomize(tabs) {
    const sectionActive = [this.elements.bundle.container, this.elements.customize.container];
    if (sectionActive) {
      sectionActive.forEach((section) => {
        var observer = new IntersectionObserver(
          function (entries) {
            const { isIntersecting, target, boundingClientRect, intersectionRect, intersectionRatio } = entries[0];

            if (isIntersecting) {
              if (target.classList.contains('bundle') && boundingClientRect.y < -60) {
                tabs.forEach((tab) => (entries[0].target.classList.contains(tab.dataset.tab) ? tab.classList.add('active') : tab.classList.remove('active')));
              }
            }

            if (!isIntersecting && intersectionRatio == 0) {
              if (target.classList.contains('bundle') && boundingClientRect.y > 60) return;
              if (target.classList.contains('customize') && boundingClientRect.y < 60) return;
              tabs.forEach((tab) => (!entries[0].target.classList.contains(tab.dataset.tab) ? tab.classList.add('active') : tab.classList.remove('active')));
            }
          },
          {
            threshold: [0, 1],
          },
        );

        observer.observe(section);
      });
    }
  }

  scrollToMainTab(builder_type, opts = {}) {
    let scrollAmount = 0;

    if (this.elements.page_navigation) scrollAmount -= this.elements.page_navigation.offsetHeight;
    if (this.elements.builder_tabs_wrapper) {
      scrollAmount -= this.elements.builder_tabs_wrapper.offsetHeight;
      scrollAmount -= parseInt(
        window.getComputedStyle(this.elements.builder_tabs_wrapper).getPropertyValue('padding-bottom'),
        10
      );
    }

    scrollAmount += this.elements[builder_type].container.getBoundingClientRect().top;
    scrollAmount += window.scrollY;

    const behavior = this.a11yPrefersReducedMotion() ? 'auto' : 'smooth';

    window.scrollTo({ top: scrollAmount, behavior });

    // Focus after scroll so SR cursor actually follows the UI change
    if (opts.afterScrollFinalizeA11y) {
      const delay = behavior === 'smooth' ? 350 : 0; // practical, avoids "focus but no move"
      setTimeout(() => this.a11yFinalizeBuilderOpen(builder_type), delay);
    }
  }

  getMasterBanditImage() {
    const masterVariantSku = this.builderJSON.variantMaster.legacy_sku;
    const frameLocation = this.builderJSON.bundle.parameters.parentBanditFrame || 'center';
    this.updateBundleBandit('master', { dataset: { banditFrame: frameLocation, sku: masterVariantSku } });
  }

  handleVariantChange(e) {
    // update builder json
    this.builderJSON.variantMaster = e.detail.selectedVariant;

    if (this.builderJSON.variantMaster) {
      // update input master
      this.elements.master_product.name = Shopify.handleize(this.builderJSON.variantMaster.name);
      this.elements.master_product.value = `${this.builderJSON.variantMaster.id}`;
      this.elements.master_product.dataset.price = `${this.builderJSON.variantMaster.price}`;

      // update label
      this.elements.master_product_label.querySelector('.option-set__product-title').textContent = this.builderJSON.variantMaster.name;
      this.elements.master_product_label.querySelector('.option-set__product-price').textContent = Shopify.formatMoney(this.builderJSON.variantMaster.price, '${{ amount }}');
      if (this.builderJSON.variantMaster.featured_image)
        this.elements.master_product_label.querySelector('.option-set__master-image').src = `${this.builderJSON.variantMaster.featured_image.src}&width=71`;
      this.elements.master_product_label.querySelector('.option-set__master-image').alt = this.builderJSON.variantMaster.name;

      // update price
      this.updatePricing();

      // update bandit image
      if (this.builderJSON.isPackage) {
        this.elements.bandit_fallback.src = this.builderJSON.variantMaster.featured_image.src;
        this.elements.bandit_fallback.alt = this.builderJSON.variantMaster.name;
      } else {
        this.getMasterBanditImage();
      }
    }

    // update in stock / out of stock
    if (
      this.builderJSON.variantMaster &&
      this.builderJSON.variantMaster.available &&
      (this.builderJSON.outOfStock.reason === 'Master Variant' || this.builderJSON.outOfStock.reason === '')
    ) {
      this.builderJSON.outOfStock.status = false;
      // update purchase action - enable atc
      Array.from([...this.elements.add_to_cart_btn, ...[this.elements.button_builder_bundle]]).forEach((atc_btn) => {
        atc_btn.setAttribute('aria-disabled', false);
        atc_btn.removeAttribute('disabled');
        atc_btn.classList.remove('builder_atc-oos', 'button--secondary-inverse');
        atc_btn.classList.add('builder_atc', 'button--primary');
        if (this.builderJSON.variantMaster.preorder_enabled) {
          atc_btn.children[0].innerHTML = atc_btn.classList.contains('button--builder-bundle')
            ? `<span>${window.variantStrings.preOrderBundle}</span>`
            : window.variantStrings.preOrder;
        } else {
          atc_btn.children[0].innerHTML = atc_btn.classList.contains('button--builder-bundle')
            ? `<span>${window.variantStrings.addToCartBundle}</span>`
            : window.variantStrings.addToCart;
        }
      });
    } else {
      if (!this.builderJSON.outOfStock.status || !this.builderJSON.variantMaster) {
        this.builderJSON.outOfStock.status = true;
        //update purchase action - disable atc
        Array.from([...this.elements.add_to_cart_btn, ...[this.elements.button_builder_bundle]]).forEach((atc_btn) => {
          atc_btn.setAttribute('aria-disabled', true);
          atc_btn.setAttribute('disabled', 'true');
          atc_btn.classList.remove('builder_atc', 'button--primary');
          atc_btn.classList.add('builder_atc-oos', 'button--secondary-inverse');
          if (!this.builderJSON.variantMaster) {
            atc_btn.children[0].innerHTML = window.variantStrings.unavailable;
          } else {
            atc_btn.children[0].innerHTML = window.variantStrings.soldOut;
          }
        });
      }
    }

    // update customizer (activate/deactivate - remove selections)
    this.handleCustomizeEnableDisable();
  }

  getBuilderJsonData() {
    this.builderJSON = this.builderJSON || JSON.parse(this.querySelector('[id^=BuilderJSON-]').textContent);
    return this.builderJSON;
  }

  handleCustomizeEnableDisable() {
    // DISABLE - if not the default variant
    if (this.builderJSON.customize.data && this.builderJSON.variantMaster.id !== this.builderJSON.variantDefault.id) {
      const selectionDataHtml = `
        <div class="current-selection">
          <img src=${this.builderJSON.variantMaster.featured_image.src}&width=200 width="200" height="200" loading="lazy" />
          <ul>
          ${this.builderJSON.variantOptions[0] ? `<li>${this.builderJSON.variantOptions[0].name}: ${this.builderJSON.variantMaster.options[0]}</li>` : ''}
          ${this.builderJSON.variantOptions[1] ? `<li>${this.builderJSON.variantOptions[1].name}: ${this.builderJSON.variantMaster.options[1]}</li>` : ''}
          ${this.builderJSON.variantOptions[2] ? `<li>${this.builderJSON.variantOptions[2].name}: ${this.builderJSON.variantMaster.options[2]}</li>` : ''}
        </ul>
        </div>
        <div class="icon-separator">
            <svg
            viewBox="0 0 14 10"
            fill="none"
            aria-hidden="true"
            focusable="false"
            role="presentation"
            class="icon icon-arrow"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
          </svg>
        </div>
        <div class="required-selection">
          <img src=${this.builderJSON.variantDefault.featured_image.src}&width=200 width="200" height="200" loading="lazy" />
          <ul>
            ${this.builderJSON.variantOptions[0] ? `<li>${this.builderJSON.variantOptions[0].name}: ${this.builderJSON.variantDefault.options[0]}</li>` : ''}
            ${this.builderJSON.variantOptions[1] ? `<li>${this.builderJSON.variantOptions[1].name}: ${this.builderJSON.variantDefault.options[1]}</li>` : ''}
            ${this.builderJSON.variantOptions[2] ? `<li>${this.builderJSON.variantOptions[2].name}: ${this.builderJSON.variantDefault.options[2]}</li>` : ''}
          </ul>
        </div>
        <hr class="builder-divider">
      `;

      this.elements.customize.disabled_overlay.querySelector('.selections-container').innerHTML = selectionDataHtml;

      // check if already disabled - update html render to have the latest variant data
      if (!this.builderJSON.customize.enabled) return;
      // if enabled - disable the customize
      if (this.builderJSON.customize.enabled) {
        // disable 3D customize if previously enabled
        this.handleCustomizeVersion({ currentTarget: { dataset: { customizeVersion: '2d' } } });

        // overlay modal informing the user what is required to enable the ability to customize
        this.elements.customize.disabled_overlay.setAttribute('open', 'true');
        this.elements.customize.builder_left.classList.add('hidden-fixed-height');
        this.elements.customize.builder_right.classList.add('hidden-fixed-height');
        this.elements.customize.customize_buttons.container.classList.add('top-zero-force');
        this.elements.customize.option_set_menu.classList.add('top-zero-force');

        // prevent customize selections from being part of the builder (price calculations, input selections, etc...) - use flag created
        this.builderJSON.customize.enabled = false;
        this.updatePricing();
        return;
      }

      return;
    }

    // ENABLE - if the default variant
    if (this.builderJSON.customize.data && this.builderJSON.variantMaster.id === this.builderJSON.variantDefault.id) {
      // check if already enabled - do nothing if true
      if (this.builderJSON.customize.enabled) return;

      // if disabled - enable the customize
      if (!this.builderJSON.customize.enabled) {
        // remove modal overlay
        this.elements.customize.disabled_overlay.removeAttribute('open');
        this.elements.customize.builder_left.classList.remove('hidden-fixed-height');
        this.elements.customize.builder_right.classList.remove('hidden-fixed-height');
        this.elements.customize.customize_buttons.container.classList.remove('top-zero-force');
        this.elements.customize.option_set_menu.classList.remove('top-zero-force');
        this.elements.customize.disabled_overlay.querySelector('.selections-container').innerHTML = '';

        // restore customize selections - use flag created
        this.builderJSON.customize.enabled = true;
        this.updatePricing();
        return;
      }

      return;
    }
  }

  updateVariantSelectorsToDefaultVariant(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.elements.variantSelector) {
      Array.from(this.elements.variantSelector.querySelectorAll('select option:first-of-type, fieldset input:first-of-type'), (optionTarget) => {
        if (optionTarget.tagName === 'INPUT') optionTarget.checked = true;
        if (optionTarget.tagName === 'OPTION') optionTarget.selected = true;
      });
      this.elements.variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
      this.switchBuilderTab({ currentTarget: { dataset: { tab: 'customize' } } });
    }
  }

  updateBundleBackground(e) {
    e.preventDefault();
    const { backgroundName } = e.currentTarget.dataset;
    if (!backgroundName) return;

    const updateActiveBackground = this.builderJSON.bundle_background.available.find((backgroundObj) => backgroundObj.name === backgroundName);
    if (updateActiveBackground) {
      this.elements.bundle.bundle_bandit_backgrounds.forEach((background) => {
        if (updateActiveBackground.name === background.dataset.backgroundName) {
          background.ariaCurrent = 'true';
        } else {
          background.ariaCurrent = null;
        }
      });
      this.builderJSON.bundle_background.active = updateActiveBackground;
      if (this.elements.bundle.bundle_bandit)
        this.elements.bundle.bundle_bandit.style.backgroundImage = `url('${this.builderJSON.bundle_background.active.unified_background_frame}')`;

      if (window.matchMedia('(max-width: 798px)').matches) {
        this.openCloseMobileBundleBackgroundSelector(e);
      }
    }
  }

  openCloseMobileBundleBackgroundSelector(e) {
    e.preventDefault();
    if (this.elements.bundle.bundle_bandit_background !== null) {
      if (e.currentTarget.classList.contains('mobile-open')) {
        this.elements.bundle.bundle_bandit_background.classList.add('open');
      }
      if (e.currentTarget.classList.contains('mobile-close') || e.currentTarget.classList.contains('bundle-bandit-background')) {
        this.elements.bundle.bundle_bandit_background.classList.remove('open');
      }
    }
  }

  async getImageFromAmazonS3(sku, location) {
    let frameBackground = 'wood';
    const frameLocation = location.substring(0, 1);
    const frameBackgroundImage = this.builderJSON.bundle.parameters.parentBanditImage || null;

    if (frameBackgroundImage) {
      const imageSplit = frameBackgroundImage.split('/');
      const imageBackgroundMaterial = imageSplit[imageSplit.length - 3];
      frameBackground = imageBackgroundMaterial;
    }

    const s3Image = await fetch(`https://s3.amazonaws.com/static.wholelattelove.com/?list-type=2&prefix=bandit/v2/${frameBackground}/${frameLocation}/${sku}`)
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const s3Xml = parser.parseFromString(text, 'application/xml');
        const potentialImages = Array.from(s3Xml.documentElement.querySelectorAll('Contents'))
          .filter(
            (element) =>
              element.children[0].textContent.toLowerCase().includes('.jpg') ||
              element.children[0].textContent.toLowerCase().includes('.jpeg') ||
              element.children[0].textContent.toLowerCase().includes('.png'),
          )
          .map((element) => ({
            imageSrc: `https://static.wholelattelove.com/${element.children[0].textContent}`,
            date: element.children[1].textContent,
            timestamp: Date.parse(element.children[1].textContent),
          }))
          .sort(function (a, b) {
            return b.timestamp - a.timestamp;
          });

        // Added -IMG to handle all edge cases
        const matchingSKU = potentialImages.find((image) => image.imageSrc.includes(`${sku}-IMG`) || image.imageSrc.includes(`${sku}_`));

        if (matchingSKU) {
          return matchingSKU;
        } else {
          const selected_legacy_background = this.builderJSON.bundle_background.legacy.find((bg) => bg.name === frameBackground);
          const empty_frame = `${selected_legacy_background[`${location}_empty_frame`]}`;
          return empty_frame;
        }
      })
      .catch((e) => {
        console.error(e);
      });

    return s3Image;
  }

  async getImageFromShopify(sku, location) {
    const frame = location.substring(0, 1);

    let frameType = 'r'; // future use 'narrow';
    if (frame === 'c') {
      frameType = 'c'; // future use 'wide';
    }

    const cdnHostDomain = window.Shopify.cdnHost.split('/')[0];

    const filename = `bundlerphoto_${sku.toUpperCase()}_${frameType.toUpperCase()}_0`;

    const shopifyImage = await fetch(`https://${cdnHostDomain}/pages/sale?view=bundler-image-endpoint&filename=${filename}&page=${Date.now()}`)
      .then((response) => response.json())
      .then((imageUrl) => {
        if (imageUrl) {
          return `https:${imageUrl}`;
        } else {
          return null;
        }
      })
      .catch((e) => {
        console.error(e);
      });
    return shopifyImage;
  }

  handleGwpItemClick(e) {
    const inputGwp = e && e.currentTarget.querySelector('.js-builder-option-input');
    const checkboxGwp = e && e.currentTarget.querySelector('[type="checkbox"].js-builder-option-input');
    // Ignore click events on enabled checkboxes (will use the change event instead)
    if (checkboxGwp && !checkboxGwp.disabled && e.type === 'click') {
      return;
    }
    if (this.options_bundle && this.options_bundle.length > 0) {
      // findMatchingItem - gwp or option set - check existance
      const matchingOptionInOptionSet = this.options_bundle.find((option) => {
        const inputOption = option.input;
        if (inputOption.name === inputGwp.name && inputOption.value === inputGwp.value) return option;
      });
      matchingOptionInOptionSet.input.checked = inputGwp.checked;
      this.updatePricing();

      if (this.elements.gwp_choose && this.elements.gwp_items && this.elements.gwp_items.length > 0) {
        const checkedItems = Array.from(this.elements.gwp_items).filter((item) => item.querySelector('.js-builder-option-input').checked);
        if (checkboxGwp) {
          this.elements.gwp_choose.textContent = `Choose your gifts! (${checkedItems.length} out of ${this.elements.gwp_items.length} selected)`;
        } else {
          this.elements.gwp_choose.textContent = `Choose one gift! (${checkedItems.length} out of 1 selected)`;
        }
      }
    }
  }

  handleLegacyBanditSetup() {
    let frameBackground = 'wood';
    const frameBackgroundImage = this.builderJSON.bundle.parameters.parentBanditImage || null;

    if (frameBackgroundImage) {
      const imageSplit = frameBackgroundImage.split('/');
      const imageBackgroundMaterial = imageSplit[imageSplit.length - 3];
      frameBackground = imageBackgroundMaterial;
    }

    this.legacy_bandit = { active: true, background: frameBackground };
    if (this.elements.bundle.bundle_bandit) this.elements.bundle.bundle_bandit.classList.add('legacy');
    if (this.elements.bundle.bundle_bandit) this.elements.bundle.bundle_bandit.style.backgroundImage = 'none';
    if (this.elements.bundle.bundle_bandit_background) this.elements.bundle.bundle_bandit_background.remove();
    this.updateBundleBandit('option', { dataset: { banditFrame: 'left', sku: 'EMPTY' } }, true);
    this.updateBundleBandit('option', { dataset: { banditFrame: 'center', sku: 'EMPTY' } }, true);
    this.updateBundleBandit('option', { dataset: { banditFrame: 'right', sku: 'EMPTY' } }, true);
  }

  /** -----------------------------
   * A11Y helpers (add once)
   * ----------------------------- */

  a11yEnsureStatusEl() {
    // Reuse if already created
    if (this.elements?.sr_status && document.contains(this.elements.sr_status)) return this.elements.sr_status;

    // Prefer an existing node if you add one in theme:
    // <div id="sr-status" role="status" aria-live="polite" aria-atomic="true"></div>
    let el = document.getElementById('sr-status');

    if (!el) {
      el = document.createElement('div');
      el.id = 'sr-status';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');

      // Inline "sr-only" styles so you don't depend on global CSS
      el.style.position = 'absolute';
      el.style.width = '1px';
      el.style.height = '1px';
      el.style.padding = '0';
      el.style.margin = '-1px';
      el.style.overflow = 'hidden';
      el.style.clip = 'rect(0, 0, 0, 0)';
      el.style.whiteSpace = 'nowrap';
      el.style.border = '0';

      document.body.appendChild(el);
    }

    this.elements = this.elements || {};
    this.elements.sr_status = el;
    return el;
  }

  a11yAnnounce(msg) {
    const statusEl = this.a11yEnsureStatusEl();
    // Clear then set on next frame so repeated messages still announce
    statusEl.textContent = '';
    requestAnimationFrame(() => {
      statusEl.textContent = msg;
    });
  }

  a11yPrefersReducedMotion() {
    return !!window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  }

  a11yGetContainer(builder_type) {
    return this.elements?.[builder_type]?.container || null;
  }

  a11yGetHeading(builder_type, container) {
    // Best-effort: use an explicit heading if you add data attr in markup:
    // <h2 data-builder-heading ...>...</h2>
    let heading = container?.querySelector('[data-builder-heading]');

    // Fallbacks: first heading in the container
    if (!heading) heading = container?.querySelector('h1, h2, h3, [role="heading"]');

    // Last resort: container itself (not ideal, but better than nothing)
    return heading || container || null;
  }

  a11yEnsureRegionSemantics(builder_type, container, heading) {
    if (!container) return;

    // Ensure container has an id so aria-controls can point somewhere
    if (!container.id) container.id = `builder-${builder_type}`;

    // Region landmark (non-breaking enhancement)
    if (!container.getAttribute('role')) container.setAttribute('role', 'region');

    if (heading) {
      if (!heading.id) heading.id = `${container.id}-heading`;
      if (!container.getAttribute('aria-labelledby')) container.setAttribute('aria-labelledby', heading.id);

      // Make heading programmatically focusable (without adding to tab order)
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
    } else {
      // If no heading found, at least label the region
      if (!container.getAttribute('aria-label')) {
        container.setAttribute('aria-label', builder_type === 'bundle' ? 'Bundle Options' : 'Customize Options');
      }
    }
  }

  a11yWaitForFirstControl(root, timeoutMs = 4000) {
    return new Promise((resolve) => {
      if (!root) return resolve(null);

      const selector = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

      const existing = root.querySelector(selector);
      if (existing) return resolve(existing);

      const obs = new MutationObserver(() => {
        const el = root.querySelector(selector);
        if (el) {
          obs.disconnect();
          resolve(el);
        }
      });

      obs.observe(root, { childList: true, subtree: true });

      setTimeout(() => {
        obs.disconnect();
        resolve(null);
      }, timeoutMs);
    });
  }

  a11yStartBuilderOpen(builder_type, triggerEl) {
    const container = this.a11yGetContainer(builder_type);
    const heading = this.a11yGetHeading(builder_type, container);

    this.a11yEnsureRegionSemantics(builder_type, container, heading);

    // Trigger wiring (best-effort)
    if (triggerEl && container?.id) {
      triggerEl.setAttribute('aria-controls', container.id);
      triggerEl.setAttribute('aria-expanded', 'true');
    }

    // Busy while UI opens/renders
    if (container) container.setAttribute('aria-busy', 'true');

    // Announce + intent
    const label = builder_type === 'bundle' ? 'Opening bundler. Moving to bundle options.' : 'Opening customize. Moving to customize options.';
    this.a11yAnnounce(label);

    return { container, heading };
  }

  async a11yFinalizeBuilderOpen(builder_type) {
    const container = this.a11yGetContainer(builder_type);
    const heading = this.a11yGetHeading(builder_type, container);

    this.a11yEnsureRegionSemantics(builder_type, container, heading);

    // If focus is not already inside the container, move it to the heading
    if (container && heading && !container.contains(document.activeElement)) {
      // preventScroll avoids fighting the smooth scroll
      heading.focus({ preventScroll: true });
    }

    // Wait for controls (optional but recommended)
    const firstControl = await this.a11yWaitForFirstControl(container);

    if (container) container.removeAttribute('aria-busy');

    if (firstControl) {
      // You can optionally focus the first control instead of the heading:
      // firstControl.focus({ preventScroll: true });

      this.a11yAnnounce(builder_type === 'bundle' ? 'Bundle options ready. Use Tab to choose items.' : 'Customize options ready. Use Tab to adjust options.');
    } else {
      // Still announce opened even if we didn't detect controls
      this.a11yAnnounce(builder_type === 'bundle' ? 'Bundle section opened.' : 'Customize section opened.');
    }
  }
}

customElements.define('product-builder', ProductBuilder);
